export default __webpack_public_path__ + "static/media/podcast.7c4c870e.png";